import { createSlice } from '@reduxjs/toolkit'
import { AuthUserType } from '../types/authUserTypes'
import { getFormattedi18nLanguage } from '../utils/formatUtils'

const userInfo = JSON.parse(
  localStorage.getItem('userInfo') ?? '{}',
) as AuthUserType

const currentUserType = localStorage.getItem('userType') || ''

const userToken = localStorage.getItem('userToken')
  ? localStorage.getItem('userToken')
  : null

const theme = localStorage.getItem('theme')

const initialState = {
  userInfo, // for user object
  userToken, // for storing the JWT
  refreshToken: localStorage.getItem('refreshToken') || null,
  currentUserType, // for storing the current user type
  theme,
}

const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    setToken: (state, { payload }) => {
      state.userToken = payload
      localStorage.setItem('userToken', payload)
      // old portal token
      localStorage.setItem('token', payload)
      localStorage.setItem('loggedIn', 'true')
    },
    setRefreshToken: (state, { payload }) => {
      state.refreshToken = payload
      if (payload) {
        localStorage.setItem('refreshToken', payload)
      } else {
        localStorage.removeItem('refreshToken')
      }
    },
    setCurrentUserType: (state, { payload }) => {
      state.currentUserType = payload
      localStorage.setItem('userType', payload)
    },
    setUserInfo: (state, { payload }) => {
      const updatedPayload = {
        ...payload,
        language: getFormattedi18nLanguage(payload.language),
        lastUpdated: Date.now(),
      }

      state.userInfo = updatedPayload
      localStorage.setItem('userInfo', JSON.stringify(updatedPayload))
      // old portal items
      localStorage.setItem('currentUser', JSON.stringify(updatedPayload))
      localStorage.setItem('users', '[]')
      const users = JSON.parse(localStorage.getItem('users') ?? '[]')

      users.push({ token: localStorage.getItem('token') ?? '', data: payload })
      localStorage.setItem('users', JSON.stringify(users))
    },
    setTheme: (state, { payload }) => {
      state.theme = payload
      localStorage.setItem('theme', payload)
      localStorage.setItem('colorScheme', payload)
    },
    logout: (state) => {
      // new portal items
      localStorage.removeItem('userToken')
      localStorage.removeItem('refreshToken')
      localStorage.removeItem('userType')
      localStorage.removeItem('userInfo')
      // // old portal items
      localStorage.removeItem('currentUser')
      localStorage.removeItem('token')
      localStorage.removeItem('users')
      localStorage.setItem('loggedIn', 'false')
      // states
      state.userInfo = {} as AuthUserType
      state.userToken = null
      state.refreshToken = null
      state.currentUserType = ''
    },
  },
  extraReducers: {},
})

export const {
  setUserInfo,
  logout,
  setToken,
  setRefreshToken,
  setTheme,
  setCurrentUserType,
} = authSlice.actions

export default authSlice.reducer
